<template>
  <div class="hello">
      <div class="editMyTop">
          <ShowNavHead/>
      </div>
      <div class="MyBox">
          <div class="editMyTitle">修改个人资料</div>
          <div class="DataArea">
              <div class="DataAreaInput">
                  <div><span style="color:#F5222D">*  </span>用户姓名</div>
                  <input type="text" class="myDateInput" v-model="userName.value" :class="{'error_border':userName.check}" @blur="blurCheckInput('userName')">
                  <p class="error_text0" v-if="userName.check">请填写用户姓名</p>
              </div>
              <div class="DataAreaInput">
                  <div><span style="color:#F5222D">*  </span>手机号码</div>
                  <input type="tel" class="myDateInput" v-model="userTel.value" :class="{'error_border': userTel.check}" @blur="blurCheckInput('userTel','phone')">
                  <p class="error_text0" v-if="userTel.check">请检查手机格式</p>
              </div>
              <div class="DataAreaInput">
                  <div><span style="color:#F5222D">*  </span>登录邮箱</div>
                  <input type="email" class="myDateInput" v-model="userEmail.value" :class="{'error_border': userEmail.check}" @blur="blurCheckInput('userEmail','mail')">
                  <p class="error_text0" v-if="userEmail.check">请检查邮箱格式</p>
              </div>
              <!-- <div class="DataAreaInput">
                <div><span style="color:#F5222D">*  </span>账号密码</div>
                <input type="password" class="myDateInput">
              </div> -->
          </div>
          <div class="DataAreaInput">
              <button class="exportButton" style="margin-right:20px">确认修改</button>
          </div>
      </div>
  </div>
</template>

<script>
import FUN from "../../assets/employee/js/fun";
export default {
  data () {
    return {
      userName:{
        value:"",
        check:false
        },
      userTel:{
        value:"",
        check:false
        },
      userEmail:{
        value:"",
        check:false
        }
    }
  },
  methods : {
    blurCheckInput(val, type){
      if(this[val].value){
        // 联系人姓名
        const check_data = FUN.identityValue(this, this[val], type ? type : "empty");
        console.log(check_data);
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .MyBox{
       background-color: #FFFFFF;
       margin: 15px;
       padding-bottom: 30px;
   }
</style>
